import Content from '@/layout/content';
import Layout from '@/layout';

export default {
  path: '/rg05',
  component: window.name ? Content : Layout,
  meta: {
    title: '首页',
    icon: 'iconfont icon-home',
    code: '01020101'
  },
  children: [
    {
      path: '',
      name: 'ciaeRms',
      component: () => import('@/views/rg05'),
      meta: {
        activeMenu: '/rg05'
      }
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
